import { User, makeAuthenticatedRequest } from './authService';

export interface Activity {
    id: number;
    user_id: number;
    action_type: string;
    details: object;
    created_at: string;
}

export interface ActivityFilters {
    startDate?: string;
    endDate?: string;
    actionType?: string;
    limit?: number;
}

export const trackAction = async (user: User | null, action_type: string, details: object = {}) => {
    if (!user) {
        // Don't track actions for logged-out users, or handle as anonymous
        return;
    }

    try {
        await makeAuthenticatedRequest('/user-activities', {
            method: 'POST',
            body: JSON.stringify({
                action_type,
                details,
            }),
        });
    } catch (error) {
        console.error('Error tracking action:', error);
        // Silently fail to not disrupt user experience
    }
};

export const getActivities = async (filters?: ActivityFilters): Promise<Activity[]> => {
    try {
        const queryParams = new URLSearchParams();
        
        if (filters?.startDate) {
            queryParams.append('start_date', filters.startDate);
        }
        if (filters?.endDate) {
            queryParams.append('end_date', filters.endDate);
        }
        if (filters?.actionType) {
            queryParams.append('action_type', filters.actionType);
        }
        if (filters?.limit) {
            queryParams.append('limit', filters.limit.toString());
        }

        const queryString = queryParams.toString();
        const url = `/user-activities${queryString ? `?${queryString}` : ''}`;

        const data = await makeAuthenticatedRequest(url, {
            method: 'GET',
        });

        return data.activities || [];
    } catch (error) {
        console.error('Error fetching activities:', error);
        throw error;
    }
};

export interface ActivityCountsResponse {
    success: boolean;
    start_date: string;
    end_date: string;
    counts_by_date: { [date: string]: number };
    total_count: number;
}

export const getActivityCounts = async (startDate: string, endDate: string): Promise<ActivityCountsResponse> => {
    try {
        const queryParams = new URLSearchParams();
        queryParams.append('start_date', startDate);
        queryParams.append('end_date', endDate);

        const url = `/user-activities/counts?${queryParams.toString()}`;

        const data = await makeAuthenticatedRequest(url, {
            method: 'GET',
        });

        return data;
    } catch (error) {
        console.error('Error fetching activity counts:', error);
        throw error;
    }
};